import React, { useContext, useMemo } from 'react';
import styled from 'styled-components';
import { Field } from 'react-final-form';
import {
  User,
  FlexSpace,
  FlexColumn,
  Small,
  RatingBar,
  InputField as BaseInputField,
  SelectField
} from '@ubeya/shared-web/components';
import { responsiveRow, media } from '@ubeya/shared-web/style';
import useJobTypes from '@ubeya/shared/hooks/generic/useJobTypes';
import ConfigContext from '@ubeya/shared-web/contexts/ConfigContext';

const CONTRACT_FEATURE_ALLOWED_JOB_TYPE_IDS = new Set([1, 2]);

const Wrapper = styled(FlexSpace)`
  ${responsiveRow.tablet}
  > div {
    margin-bottom: 30px;
    ${media.tablet`margin-bottom: 0;`}
  }
`;

const RateText = styled(Small)`
  margin-bottom: 8px;
`;

const InputField = styled(BaseInputField)`
  width: ${({ isJob }) => (isJob ? 30 : 55)}%;
`;

const UserShift = ({ image, firstName, lastName, rating, setEmployee, isJob, readOnly = false }) => {
  const { t, enableContractFeature } = useContext(ConfigContext);
  const { jobTypesOptions } = useJobTypes();

  const filteredJobTypesOptions = useMemo(() => {
    if (!enableContractFeature) return jobTypesOptions;
    return (jobTypesOptions || []).filter(({ value }) => CONTRACT_FEATURE_ALLOWED_JOB_TYPE_IDS.has(value));
  }, [enableContractFeature, jobTypesOptions]);

  const setEmployeeRate = (newValue, input) => {
    input.onChange(newValue === input.value ? null : newValue);
  };

  return (
    <Wrapper>
      <User
        image={image}
        firstName={firstName}
        lastName={lastName}
        showRating
        rating={rating}
        size="big"
        onClick={setEmployee}
        withUnderline
      />

      {isJob && (
        <SelectField name="jobTypeId" options={filteredJobTypesOptions} isMulti={false} isDisabled={readOnly} />
      )}

      <FlexColumn>
        <RateText>{t('rateUserShift', { firstName })}</RateText>
        <Field
          name="rating"
          render={({ input }) => (
            <RatingBar rating={input.value} onChange={(newValue) => setEmployeeRate(newValue, input)} />
          )}
        />
      </FlexColumn>

      <InputField
        name="review"
        placeholder={t('writeReviewAboutShift')}
        isJob={isJob}
        isMultiline
        readOnly={readOnly}
      />
    </Wrapper>
  );
};

export default UserShift;
